import { AlertTriangle } from "lucide-react";

import { Alert, AlertDescription } from "@/components/ui/alert";

interface AlertSectionProps {
  alert: string;
}

const AlertSection = ({ alert }: AlertSectionProps) => {
  const isAlert = alert && alert.toLowerCase() !== "none";

  if (!isAlert) return null;

  return (
    <div className="p-4 pb-0">
      <Alert key={`alert-section`} className="border-red-600/30 bg-red-900/20">
        <AlertTriangle className="size-4 text-red-400" />
        <AlertDescription className="text-red-200">
          <span className="font-medium">Critical Alert:</span> {alert}
          {/* <span className="text-xs text-red-300">(now)</span> */}
        </AlertDescription>
      </Alert>
    </div>
  );
};

export default AlertSection;
